import React from "react";
import { observer } from "mobx-react";
import { Skeleton, WidgetEmptyErrorPlaceholder } from "@ann/web-components";
import {
  ContentContainer,
  GridContainer,
  ErrorWrapper,
  EmptyWrapper,
} from "./Content.styled";
import AgentCard from "../../../AgentsView/components/AgentCardContent/AgentCard";

const Content = observer(({ loading, error, agents, onRefresh }) => {
  if (loading) {
    return (
      <ContentContainer>
        <GridContainer>
          {[...Array(6)].map((_, index) => (
            <Skeleton key={index} height="300px" width="100%" />
          ))}
        </GridContainer>
      </ContentContainer>
    );
  }

  if (error) {
    return (
      <ContentContainer>
        <ErrorWrapper>
          <WidgetEmptyErrorPlaceholder
            icon="error"
            title="Something went wrong"
            message="We couldn't load agents. Please try again."
            buttonText="Retry"
            showButton={true}
            onClick={onRefresh}
          />
        </ErrorWrapper>
      </ContentContainer>
    );
  }

  if (!agents?.length) {
    return (
      <ContentContainer>
        <EmptyWrapper>
          <WidgetEmptyErrorPlaceholder
            icon="searchOff"
            title="No agents to display"
            message="Agent information will appear here as soon as it's available."
            showButton={false}
          />
        </EmptyWrapper>
      </ContentContainer>
    );
  }

  return (
    <ContentContainer>
      <GridContainer>
        {agents.map((agent) => {
          const agentUuid = agent?.uuid || agent?.id;
          return (
            <AgentCard key={agentUuid} agent={agent} />
          );
        })}
      </GridContainer>
    </ContentContainer>
  );
});

export default Content;

